import React, { useId } from "react";
import type { PageThemeTokens } from "../theme/types";

interface V2EndingIllustrationProps {
  tokens: PageThemeTokens;
  size?: number;
  className?: string;
}

/** 结束页勾选图标 — 填充/描边随主题用户渐变色 */
const V2EndingIllustration: React.FC<V2EndingIllustrationProps> = ({
  tokens,
  size = 106,
  className,
}) => {
  const uid = useId().replace(/:/g, "");
  const fillId = `uchat-ending-fill-${uid}`;
  const strokeId = `uchat-ending-stroke-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 106 106"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <defs>
        <linearGradient id={fillId} x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor={tokens.chatUserGradientStart} />
          <stop offset="100%" stopColor={tokens.chatUserGradientEnd} />
        </linearGradient>
        <linearGradient id={strokeId} x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor={tokens.chatUserGradientStart} stopOpacity="0.75" />
          <stop offset="50%" stopColor="#FFFFFF" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>
      <circle
        cx="53"
        cy="53"
        r="52.5"
        fill={`url(#${fillId})`}
        stroke={`url(#${strokeId})`}
      />
      <g transform="translate(25 32)" fill="#FFFFFF" fillRule="nonzero">
        <polygon points="20.6878181 28.2785638 6.89682746 14.5539625 0 21.4175888 20.6819735 42 21.5241995 41.1618285 21.5300441 41.167645 56 6.86362634 49.1031725 0" />
      </g>
    </svg>
  );
};

export default V2EndingIllustration;
